var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-dependency-injection";
import * as Enumerable from "linq";
import { I18N } from "aurelia-i18n";
import { EventAggregator } from "aurelia-event-aggregator";
import { BindingEngine } from "aurelia-binding";
import { NotificationClientService } from "../../../../../../../services/basics/notification-client.service";
import { BrandClientService, TemplateType, BrandingType } from "../../../../../../../services/modules/brand-client.service";
import { TokenClient } from "../../../../../../../services/authentication/token-client.service";
import { BrandingBase } from '../../../../branding/branding-base';
import { LotteryClientService } from "../../../../../../../services/modules/lottery-client.service";
import { LotteryHelper } from "../../../../../client/utilities/lottery-string-helper";
import { BindingSignaler } from "aurelia-templating-resources";
import { LotteryTags } from "../../../../../../../models/modules/lotteryplatform-client.models";
var QuickPlayBranding = /** @class */ (function (_super) {
    __extends(QuickPlayBranding, _super);
    function QuickPlayBranding(notificationService, i18N, brandClientService, bindingEngine, eventAggregator, lotteryClientService, tokenClient, bindingSignaler) {
        var _this = _super.call(this, notificationService, i18N, brandClientService, bindingEngine, eventAggregator, tokenClient, bindingSignaler) || this;
        _this.lotteryClientService = lotteryClientService;
        _this.lotteries = [];
        return _this;
    }
    QuickPlayBranding.prototype.onActivated = function (item) {
        var _this = this;
        _super.prototype.onActivated.call(this, item);
        this.lotteryClientService.getLotteriesByBrand(item.isManagingDefaultConfig ? null : item.model.brandId, item.isManagingDefaultConfig).then(function (x) {
            _this.lotteries = LotteryTags.getTags().map(function (x) { return ({
                name: x
            }); }).concat(Enumerable.from(x).select(function (a) { return a.lottery; }).toArray());
        });
    };
    QuickPlayBranding.prototype.onSelectedItemChanged = function ($event, item) {
        if ($event.detail.item && item) {
            item.key = LotteryHelper.getLotteryKey($event.detail.item.name);
            if ($event.detail.item.id) {
                item.lotteryId = $event.detail.item.id.toString();
            }
        }
    };
    QuickPlayBranding.prototype.getTemplateType = function () {
        return TemplateType.Lobby;
    };
    QuickPlayBranding.prototype.getBrandingType = function () {
        return BrandingType.QuickPlay;
    };
    QuickPlayBranding.prototype.getBrandDetails = function () {
        return {
            brandId: this.item.model.brandId,
            brandName: this.item.model.name,
            brandLanguages: Enumerable.from(this.item.model.brandLanguages).select(function (x) { return x.languageId; }).toArray()
        };
    };
    QuickPlayBranding.prototype.addQuickPlayLottery = function () {
        if (this.model) {
            var quickPlayLottery = new QuickPlayLotteryModel();
            quickPlayLottery.lotteryId = null;
            quickPlayLottery.key = null;
            this.model.push(quickPlayLottery);
        }
    };
    QuickPlayBranding.prototype.removeQuickPlayLottery = function (item) {
        var index = this.model.indexOf(item);
        if (index >= 0) {
            this.model.splice(index, 1);
        }
    };
    QuickPlayBranding.prototype.shouldNotFilter = function () {
        return true;
    };
    QuickPlayBranding.prototype.onLoaded = function () {
        if (this.model && this.model.length == 0) {
            var quickPlayLottery = new QuickPlayLotteryModel();
            quickPlayLottery.lotteryId = null;
            quickPlayLottery.key = null;
            this.model.push(quickPlayLottery);
        }
    };
    QuickPlayBranding = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N,
            BrandClientService, BindingEngine,
            EventAggregator, LotteryClientService, TokenClient, BindingSignaler])
    ], QuickPlayBranding);
    return QuickPlayBranding;
}(BrandingBase));
export { QuickPlayBranding };
var QuickPlayLotteryModel = /** @class */ (function () {
    function QuickPlayLotteryModel() {
    }
    return QuickPlayLotteryModel;
}());
export { QuickPlayLotteryModel };
